<template>
  <div>
    <v-card-subtitle>
      برای ادامه، پس از زدن دکمهٔ درخواست کد تأیید، کد تأیید ۶ رقمی پیامک شده به
      شماره وارد شده در پنل کاربری خودر را در کادر زیر وارد کنید.
    </v-card-subtitle>

    <!--    <v-fade-transition>-->
    <v-text-field
      v-model="otp"
      class="rounded-lg"
      v-bind="$attrs"
      @input="inputCode"
    />
    <!--    </v-fade-transition>-->

    <v-card-actions class="justify-end">
      <!--      <template v-if="!recode">-->
      <!--        درخواست مجدد:-->
      <!--        <div style="direction: ltr">-->
      <!--          <span id="min"/> : <span id="sec"/>-->
      <!--        </div>-->
      <!--      </template>-->
      <v-btn
        :loading="loading"
        class="rounded-lg btn-accept ma-0"
        depressed
        @click="sendOtp"
      >
        درخواست کد تأیید
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { Axios2 } from "@/main";
import { mapState } from "vuex";

export default {
  name: "OTPPicker",

  data() {
    return {
      loading: false,
      otp: null,
      timer: undefined,
      // recode: false,
      showField: false,
    };
  },

  computed: {
    ...mapState("divar", ["current_advertise_contact_phone"]),
  },

  methods: {
    sendOtp() {
      this.loading = true;
      this.showField = true;

      Axios2.post(
        `${this.$robotApi}/divar/advertise/sendOtp/${this.current_advertise_contact_phone}`
      )
        .then(({ data }) => {
          data?.message && this.$toast.success(data.message);
          // this.startTimer()
        })
        .catch(({ response }) => {
          response?.data?.message && this.$toast.error(response.data.message);
          console.log("failed to send opt: ", response);
        })
        .finally(() => (this.loading = false));
    },
    inputCode() {
      this.$emit("input", this.otp);
      this.$emit("change", this.otp);
    },
    // startTimer() {
    //   let time = 120
    //   this.recode = false
    //
    //   this.timer = setInterval(() => {
    //     let minutes = Math.floor(time / 60).toString().padStart(2, '0');
    //     let seconds = Math.floor(time % 60).toString().padStart(2, '0');
    //
    //     const min_el = document.getElementById('min');
    //     const sec_el = document.getElementById('sec');
    //     min_el.innerText = minutes
    //     sec_el.innerText = seconds
    //
    //     time--;
    //
    //     if (time < 0) {
    //       clearInterval(this.timer)
    //       this.recode = true
    //     }
    //
    //   }, 1000)
    // }
  },
};
</script>

<style scoped></style>
